// src/components/artists/ArtistNoLinkState.tsx
import React from 'react';
import { PlusCircleIcon } from '@heroicons/react/24/outline';
import ArtistSearch from './ArtistSearch';

interface ArtistNoLinkStateProps {
  showArtistSearch: boolean;
  setShowArtistSearch: (show: boolean) => void;
}

export const ArtistNoLinkState: React.FC<ArtistNoLinkStateProps> = ({
  showArtistSearch,
  setShowArtistSearch
}) => {
  return (
    <div className="container mx-auto py-8">
      <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 rounded-lg p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">No Artist Linked</h2>
        <p className="mb-4">
          You haven't linked your Spotify artist profile yet. Link your artist profile to start tracking your metrics.
        </p>
        <button
          onClick={() => setShowArtistSearch(true)}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          <PlusCircleIcon className="h-5 w-5 mr-2" />
          Link an Artist Profile
        </button>
      </div>

      {showArtistSearch && (
        <div className="mt-6">
          <ArtistSearch 
            onArtistSelected={(artist) => {
              // After successful linking, reload the page
              window.location.reload();
            }}
            redirectAfterLink="/artist/me"
          />
        </div>
      )}
    </div>
  );
};